import axios from "axios";
export function sendMailOrder(postData) {
   
    return axios.post('https://2yhrka7axi.execute-api.us-west-2.amazonaws.com/prod/contactus', postData)
    // return fetch(awsLambdUrl+'/sendmail?subject='+subject+'&mail_text='+mail_text+'&to='+to, {
    //method: 'POST',
}